// src/components/strumenti/TempoTrasferimento.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function TempoTrasferimento() {
  const [dimensione, setDimensione] = useState("");
  const [unitaDim, setUnitaDim] = useState("GB");
  const [velocita, setVelocita] = useState("");
  const [unitaVel, setUnitaVel] = useState("mbps");

  const d = leggiNumero(dimensione)||0;
  const v = leggiNumero(velocita)||0;

  const dimensioneBit = unitaDim==="MB" ? d*8000000 : unitaDim==="GB" ? d*8000000000 : d*8000000000000; // TB
  const velocitaBps = unitaVel==="mbps" ? v*1000000 : unitaVel==="gbps" ? v*1000000000 : v*1000; // kbps

  const secondi = velocitaBps>0 ? dimensioneBit/velocitaBps : null;

  const formatTempo = s => {
    if (s===null) return "—";
    if (s<60) return `${s.toFixed(0)} secondi`;
    if (s<3600) return `${(s/60).toFixed(1)} minuti`;
    if (s<86400) return `${(s/3600).toFixed(1)} ore`;
    return `${(s/86400).toFixed(1)} giorni`;
  };

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:10, marginBottom:12 }}>
        <div>
          <label style={lbl}>Dimensione file/dati</label>
          <input value={dimensione} onChange={e=>setDimensione(e.target.value)} style={inp} placeholder="Es. 500"/>
        </div>
        <div>
          <label style={lbl}>Unità</label>
          <select value={unitaDim} onChange={e=>setUnitaDim(e.target.value)} style={inp}>
            <option value="MB">MB</option>
            <option value="GB">GB</option>
            <option value="TB">TB</option>
          </select>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:10, marginBottom:16 }}>
        <div>
          <label style={lbl}>Velocità di rete</label>
          <input value={velocita} onChange={e=>setVelocita(e.target.value)} style={inp} placeholder="Es. 100"/>
        </div>
        <div>
          <label style={lbl}>Unità</label>
          <select value={unitaVel} onChange={e=>setUnitaVel(e.target.value)} style={inp}>
            <option value="kbps">kbps</option>
            <option value="mbps">Mbps</option>
            <option value="gbps">Gbps</option>
          </select>
        </div>
      </div>

      <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Tempo stimato di trasferimento</div>
        <div style={{ fontSize:20, fontWeight:800, color:"#2563eb" }}>{formatTempo(secondi)}</div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Stima teorica alla velocità massima dichiarata — la velocità reale è quasi sempre inferiore.
      </div>

      <button onClick={()=>{setDimensione("");setVelocita("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
